import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  FormControl,
  Select,
  MenuItem,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
function Device_model_filter({resetDate, modelwiseOnboardDevices, setModalFilterType, setDevicesCatogary, devicesCatogary, setSelectedFilter, allowedDeviceCategories}) {
  const [modalFilter, setModalFilter] = useState({})

  useEffect(() => {
    setModalFilterType(modalFilter)
  }, [modalFilter]);

  useEffect(() => {
    if(modelwiseOnboardDevices.length){
      const data = JSON.parse(JSON.stringify(modelwiseOnboardDevices))
      let arr = [];
      for(let i = 0 ; i < data.length ; i++) {
        let tempArr = Object.keys(data[i].modelCategories)
        arr.push(...tempArr)
      }
      let unique = [...new Set(arr)];
      let checkArr = []
      unique.forEach(v => checkArr[v] = true)
      setModalFilter(checkArr)
    }
  }, [modelwiseOnboardDevices]);
  const handleControllerChange = (event) => {
    modalFilter[event.target.name] = event.target.checked;
    setModalFilter({...modalFilter , [event.target.name]:event.target.checked})
  }
  const handleDeviceCategory = (event) => {
    setDevicesCatogary(event.target.value);
    setSelectedFilter("1");
    resetDate();
  }

  return (
    <div className="container">
      <div className="row ">
        <div className="col s12">
          <div className="content-block mb-0 p-15 radius-6">
            <div className="search-user-wraper d-flex justify-content-between align-items-center">
              <div className="page-title min-180">
              <div className="test_class">
                <Accordion className="model_select">
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography>Device Model</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                      {modelwiseOnboardDevices.length > 0 && Object.keys(modalFilter).map((model)=>(
                          <FormControlLabel
                          key={model}
                          control={
                            <Checkbox
                              checked={modalFilter[model]}
                              onChange={handleControllerChange}
                              name={model}
                              color="primary"
                            />
                          }
                          label={model}
                        />
                      ))}
                  </AccordionDetails>
                </Accordion>
              </div>
              </div>

              <div className="control-capabilities">
                <div className="model-srch reset">
                  <label className="field-name active pb-0 mb-0">
                    Device Category
                  </label>
                  <FormControl size="small" fullWidth variant="outlined" className="custom-select select-reset radius-20">
                    <Select
                      name="searchBy"
                      value={devicesCatogary ?? (allowedDeviceCategories?.[0] ?? "")}
                      onChange={handleDeviceCategory}
                      displayEmpty
                    >
                      {allowedDeviceCategories.map((category) => (
                        <MenuItem key={category} value={category}>{category}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    modelwiseOnboardDevices: state.metrics.modelwiseOnboardDevices,
  allowedDeviceCategories:state.auth.allowedDeviceCategories,

  };
};

export default connect(mapStateToProps, {})(Device_model_filter);
